<!--  -->
<template>
  <div>
    <div
      class="header df-between"
      :style="{
        'padding-top': utils.isIphoneX() ? '50px' : '30px',
        'background-color': bgColor,
        'z-index': zIndex
      }"
    >
      <i @click="handleBack()" class="back" v-if="isBack"></i>
      <!-- <img src="../../assets/images/i-arrow-left.png" alt="" class="back" > -->
      <div class="title df-center">{{ headTitle }}</div>
      <div class="right-title" v-if="showRightTile" @click="rightTileClick">
        {{ rightTitle }}
      </div>
      <i class="iconfont" v-else></i>
    </div>
    <div class="holder"  :style="{
        'height': utils.isIphoneX() ? '89px' : '68px',
      }">

    </div>
  </div>
</template>

<script>
export default {
  props: {
    headTitle: {
      // 标题名称
      type: String,
      default: "",
    },
    isBack: {
      //是否返回
      type: Boolean,
      default: true,
    },
    pageName: {
      //页面名称
      type: String,
      default: "",
    },
    bgColor: {
      type: String,
      default: "#fff",
    },
    rightTitle: {
      type: String,
      default: "",
    },
    showRightTile: {
      type: Boolean,
      default: false,
    },
    isForbidBack: {
      type: Boolean,
      default: false,
    },
    zIndex: {
      type: Number,
      default: 99
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    handleBack() {
      if (this.isBack && !this.isForbidBack) {
        this.$router.go("-1");
      } else {
        this.$emit("back");
      }
    },
    rightTileClick() {
      this.$emit("rightClick");
    },
  },
};
</script>
<style lang='scss' scoped>
.holder {
  height: 100px;
}
.header {
  padding: 15px;
  font-size: 17px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #000000;
  position: fixed;
  border-bottom: 1px solid #ececec;
  // width: 100%;
  left: 0;
  right: 0;
  z-index: 99;
  top: 0;
  .title {
    height: 20px;
    font-size: 17px;
  }
  .back {
    /* margin-right: auto; */
    width: 22px;
    height: 22px;
    background: url("../../assets/images/i-arrow-left.png");
    background-size: 100% 100%;
  }
}
</style>
